import { ComponentHelper } from "../../core/util/componentHelper";
import { TextBox } from "../../core/components/textBox";
import { Helper } from "../../core/util/helper";
import { BaseComponentProps, BaseField } from "../../core/components/baseComponentProps";
import React from "react";
export default class SignTextBox extends React.Component<SignTextBoxProps, SignTextBoxState>{
    private factory = ComponentHelper.createFactory();
    private labelText: string;


    constructor(props: SignTextBoxProps) {
        super(props)
        this.labelText = Helper.getTranslation("WebSMS.GeneralSettings.SendStatus.HasToBeHex");
        this.state = {
            value: props.value
        }
    }

    private setValue = (value: string) => {
        if (Helper.isHex(value) || Helper.isNullOrEmpty(value)) {
            this.setState({ value: value }, () => {
                this.props.onChange(this.props.field, value)
            })
        } else {
            this.setState({});
        }
    }

    private createTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.value;
        props.onChange = (_, value: string) => {
            this.setValue(value);
        }
        props.field.triggerOnChange = true;
        return (
            <div style={{ marginRight: "7px", flex: 1 }}>
                <TextBox {...props} />
            </div>
        );
    }

    private tryGetColor = () => {
        let color = this.props.field.color;
        const isColor = (value: string) => {
            if (Helper.isNullOrEmpty(value))
                return false;
            let excecuted = new RegExp("^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$").exec(value);
            return Helper.hasValue(excecuted) && excecuted[0] === color;
        }
        if (isColor(color)) {
            return color;
        }
        try {
            color = this.props.handleEval(color);
            if (isColor(color)) {
                return color;
            }
        } catch {
            return "#000000";
        }
        return "#000000";
    }

    private createSymbol = () => { 
        let innerHTML = '';
        if (!Helper.isNullOrEmpty(this.state.value))
            innerHTML = `<div style='color: ${this.tryGetColor()}'>&#x${this.state.value.toUpperCase()};</div>`
        return (
            <div style={{ fontSize: "20px" }} dangerouslySetInnerHTML={{ __html: innerHTML }}>
            </div>
        )
    }

    render() {
        return (
            <>
                <div style={{ display: "flex", alignItems: "center", width: "100%", flexDirection: "row-reverse" }}>
                    {this.createSymbol()}
                    {this.createTextBox()}
                </div>
                <div style={{ marginTop: "5px" }}>{this.labelText}</div>
            </>

        );
    }
}

interface SignTextBoxProps extends BaseComponentProps{
    value: string;
    field: SignTextBoxField;
    handleEval: (whatever) => any;
}

interface SignTextBoxField extends BaseField {
    color: string;
}

interface SignTextBoxState {
    value: string;
}